import { getIconProps, type IconProps } from '#types'

/**
 * Plus icon — two crossed lines for add / create actions.
 *
 * Geometry from the Figma "Icon set/add" glyph (18px plus on a 24 grid, 1.5 stroke).
 *
 * @example
 * ```tsx
 * <button>
 *   <PlusIcon className="h-4 w-4" /> Add exception
 * </button>
 * ```
 */
export function PlusIcon({ strokeWidth = 1.5, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M12 3V21M3 12H21"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
